import { isNotDefined } from '@sgme/fp';
import { FormattedNumber } from 'react-intl';

import { useTargetAccumulatorTileId } from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorTotalNotional } from '@/store/targetAccumulator/selectors.ts';

const TotalNotional = () => {
  const tileId = useTargetAccumulatorTileId();

  const totalNotional = useAppSelector((state) => selectTargetAccumulatorTotalNotional(state, tileId));
  if (isNotDefined(totalNotional)) {
    return null;
  }

  return (
    <span className="form-control-plaintext p-0 text-end fs-12" data-e2e="total-notional">
      <FormattedNumber value={totalNotional} />
    </span>
  );
};

export default TotalNotional;
